import { filter, take, tap } from 'rxjs/operators';
import { CoreToolBarViewModel } from '../core-tool-bar-view-model';
import { ToolBarViewModelInterface } from '../tool-bar-view-model.interface';
import { CommandsCategory } from '../commands/commands-category';
import { CommandFactory } from '../commands/command-factory';
import { CommandTypes } from '../commands/command-types';
import { firstValueFrom } from 'rxjs';
import { LongOpOrchestratorViewModelInterface } from '@nts/std/interfaces';
import { UICommandInterface } from '@nts/std/interfaces';
import { FilledButtonType } from '@nts/std/types';

export class LongOpToolBarViewModel<TOrchestratorViewModel extends LongOpOrchestratorViewModelInterface = LongOpOrchestratorViewModelInterface> extends CoreToolBarViewModel<TOrchestratorViewModel> implements ToolBarViewModelInterface {

    override get orchestrator(): TOrchestratorViewModel {
        return this._orchestrator as TOrchestratorViewModel;
    }

    async buildMenu(defaultCategory: CommandsCategory): Promise<void> {
        // aspetto il caricamento dei meta dati
        await firstValueFrom(this.orchestrator.eventDispatcher.onMetaDataLoaded.pipe(filter((loaded) => loaded), take(1)));

        this.addHomeCommandGroup();
        this.addActionCommandGroup();

        // caricamento asincrono per i report (senza await)
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        firstValueFrom(this.addReportCommandGroup().pipe(tap((command) => this.menuItemChanged.next(command))));

        await this.addRelatedCommandGroup();
        this.addCustomCommandGroups();
        this.addCustomPages();

        // caricamento asincrono per il menù altro (senza await)
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        firstValueFrom(this.addAdditionalCommandsGroups().pipe(tap((command) => this.menuItemChanged.next(command))));

        this.setDefaultCommand();
    }

    protected override setDefaultCommand() {
        this._defaultCommand = this.getExecuteLongOpCommand();
        this._defaultCommandType = FilledButtonType.Success;
    }

    protected getExecuteLongOpCommand(): UICommandInterface {
        return CommandFactory.createUICommandWithType(
            CommandTypes.ExecuteLongOp,
            async (x) => { await this.orchestrator.executeLongOp(); },
            () => this.orchestrator.canExecuteLongOp(),
            null,
            () => this.orchestrator.isVisibleExecuteLongOp()
        );
    }
}
